import React from 'react';

import Tooltip from '../../library/tooltip/tooltip';
import Typography from '../../library/typography/typography';
import StopwatchSolidIcon from '../../shared/icons/stopwatch-solid-icon';

import { useAemContent } from '../../shared/hooks/hooks';

import {
  AEM_CONTENT_IDS,
  AEM_CONTENT_PAGE_IDS
} from '../../shared/constants/cms';

import './product-promo-countdown.scss';

interface ProductPromoCountdownProps {
  countdownText: string;
  showTooltip?: boolean;
}

function ProductPromoCountdown(props: ProductPromoCountdownProps) {
  const { countdownText, showTooltip } = props;

  const { aemTooltipsContent } = useAemContent(AEM_CONTENT_PAGE_IDS.global);

  const promoTooltip =
    aemTooltipsContent?.[AEM_CONTENT_IDS.promoOfferEnds]?.tipText;

  return (
    <span className="product-promo-countdown" styleName="container">
      <StopwatchSolidIcon styleName="icon" />
      <Typography styleName="text" tag="span">
        Offer ends&nbsp;
        <time dateTime={countdownText} styleName="date">
          {countdownText}
        </time>
      </Typography>
      {showTooltip && <Tooltip content={promoTooltip} styleName="tooltip" />}
    </span>
  );
}

export default ProductPromoCountdown;
